import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Answer } from "../../types/models";

type Props = {
  answer: Answer | undefined;
};

export const QuestionStatusBadge: FC<Props> = ({ answer }) => {
  const { t } = useTranslation();

  const status =
    answer === undefined
      ? t("chapter.questionStatus.notStarted")
      : answer.completed
      ? t("chapter.questionStatus.completed")
      : t("chapter.questionStatus.inProgress");

  const color =
    answer === undefined ? "delicate" : answer.completed ? "herb" : "sand";

  const colorVariants = {
    delicate: "bg-delicate-10 text-delicate-700",
    herb: "bg-herb-10 text-herb-700",
    sand: "bg-sand-10 text-sand-700",
  };

  return (
    <span
      className={[
        "px-1.5 sm:px-2 py-1 inline-flex text-xs sm:text-sm leading-4 sm:leading-5 font-semibold rounded-full",
        colorVariants[color],
      ].join(" ")}
    >
      {status}
    </span>
  );
};
